import _jsx from '@babel/runtime/helpers/jsx';
import { useState } from 'react';
import 'prop-types';
import ChevronDown from '@andes/icons/ChevronDown16';
import ChevronUp from '@andes/icons/ChevronUp16';
import { jsxs, Fragment } from 'react/jsx-runtime';
var _ChevronUp, _ChevronDown;
const namespace$1 = "seo-ui-extended-menu";
const DEFAULT_LIMIT = 7;
const SeeMoreList = _ref => {
  var _Fragment, _Fragment3;
  let {
    items = [],
    limit = DEFAULT_LIMIT,
    seeMore,
    seeLess
  } = _ref;
  const [showAll, setShowAll] = useState(false);
  const isElementHidden = index => !showAll && index >= limit;
  const getListItemClassName = index => `${namespace$1}__link ${isElementHidden(index) ? `${namespace$1}__link--hidden` : ""}`;
  const renderSeeLess = () => _Fragment || (_Fragment = /*#__PURE__*/jsxs(Fragment, {
    children: [seeLess, " ", _ChevronUp || (_ChevronUp = /*#__PURE__*/_jsx(ChevronUp, {}))]
  }));
  const renderSeeMore = () => _Fragment3 || (_Fragment3 = /*#__PURE__*/jsxs(Fragment, {
    children: [seeMore, " ", _ChevronDown || (_ChevronDown = /*#__PURE__*/_jsx(ChevronDown, {}))]
  }));
  const renderListItems = () => /*#__PURE__*/_jsx("ul", {
    className: `${namespace$1}__list`
  }, void 0, items.map((item, index) => /*#__PURE__*/_jsx("li", {
    className: getListItemClassName(index),
    "aria-hidden": isElementHidden(index)
  }, index, /*#__PURE__*/_jsx("a", {
    className: `${namespace$1}__anchor`,
    href: item.url,
    tabIndex: isElementHidden(index) ? -1 : 0
  }, void 0, item.text))));
  return /*#__PURE__*/jsxs(Fragment, {
    children: [renderListItems(), items.length > limit && /*#__PURE__*/_jsx("button", {
      className: `${namespace$1}__see-more`,
      onClick: () => setShowAll(!showAll),
      type: "button"
    }, void 0, showAll ? renderSeeLess() : renderSeeMore())]
  });
};
const namespace = "seo-ui-extended-menu";
const ExtendedMenu = _ref => {
  let {
    title = "",
    menu = [],
    seeMore = "See more",
    seeLess = "See less",
    limit
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    className: `${namespace}`
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: `${namespace}__header`
  }, void 0, /*#__PURE__*/_jsx("h2", {
    className: `${namespace}__header__title`
  }, void 0, title)), /*#__PURE__*/_jsx("div", {
    className: `${namespace}__body`
  }, void 0, menu.map(_ref2 => {
    let {
      title: groupTitle = "",
      url = "",
      children: links = []
    } = _ref2;
    return /*#__PURE__*/_jsx("div", {
      className: `${namespace}__group`
    }, groupTitle.replaceAll(" ", ""), /*#__PURE__*/_jsx("h4", {
      className: `${namespace}__group__title`
    }, void 0, /*#__PURE__*/_jsx("a", {
      className: `${namespace}__group__title__link`,
      href: url
    }, void 0, groupTitle)), links.length > 0 && /*#__PURE__*/_jsx(SeeMoreList, {
      items: links,
      seeMore: seeMore,
      seeLess: seeLess,
      limit: limit
    }));
  })));
};
ExtendedMenu.displayName = "ExtendedMenu";
export { ExtendedMenu as default };
